import React from "react";
import { withRouter } from "react-router-dom";

import { Grid } from "@material-ui/core";
import { CardHeader, CardFooter } from "..";
import { MdBookmarkBorder } from "react-icons/md";
import { FiShare } from "react-icons/fi";

import useStyles from "./styles";

const Card = ({ data, history }) => {
  const {
    id,
    owner,
    catch_phrase: catchPrase,
    interests,
    location: campaignLocation,
    created_at,
    image,
    campaign_subscriptions
  } = data;

  const { cardRoot, cImageContainer } = useStyles({ image });

  return (
    <Grid item container className={cardRoot}>
      {owner && campaignLocation && (
        <CardHeader owner={owner} campaignLocation={campaignLocation} />
      )}

      <Grid
        item
        className={cImageContainer}
        onClick={() => history.push(`/campaigns/${id}`)}
      />

      <CardFooter
        actions={[
          {
            title: "share",
            action: () => console.log("pending share"),
            icon: <FiShare />
          },
          {
            title: "like",
            action: () => console.log("pending like"),
            icon: <MdBookmarkBorder />
          }
        ]}
        info={{ campaign_subscriptions, catchPrase, interests, created_at }}
      />
    </Grid>
  );
};

export default withRouter(Card);
